import { bookingConstants, SearchFilters } from '~/components/sitecore/bedroom-search-form/menuConfig'

function generateSynxisBookingURL(url: string, filters: SearchFilters): string {
  const queryUrl = new URL(url)
  queryUrl.searchParams.set('adult', filters.guests.adults.toString())
  queryUrl.searchParams.set('child', filters.guests.children.toString())
  queryUrl.searchParams.set('arrive', filters.dates.fromDate)
  queryUrl.searchParams.set('depart', filters.dates.toDate)
  queryUrl.searchParams.set('promo', filters.bookingFor.code || bookingConstants.BEDROOM_PROMOTION_FRIENDS)
  return queryUrl.toString()
}


export default generateSynxisBookingURL